import { Configuration, RenewalsQueryApiFactory } from 'api-clients/customer-portal';
import { getToken, PORTAL_API } from './tokenService';
    
export const renewalsQueryService = () => {
    const api = RenewalsQueryApiFactory(
        new Configuration({
            accessToken: getToken(),
        }),
        PORTAL_API,
    );
    return api;
};